/* PDP Vertical Thumbnail Slider — desktop (>=768px) only, dependency-free.
   Builds a fixed-height viewport that clips the thumbnail rail to N thumbnails
   and adds up/down chevron buttons to page through them. Cleanly tears itself
   down below 768px so the theme's native mobile layout is untouched.
   Native thumbnail click behaviour (main image swap) is left intact. */
(function() {
  var BP = 768;        // desktop breakpoint
  var VISIBLE = 4.5;   // thumbnails visible at once (4 full + a peek of the 5th)

  var built = false;
  var wrapper, track, viewport, upBtn, downBtn, items;
  var itemH = 0, gap = 0, stride = 0, index = 0, maxIndex = 0;

  function getWrapper() {
    return document.querySelector(
      '.product-single__photos > .thumbnails-wrapper, .product-single__photoss > .thumbnails-wrapper'
    );
  }

  function chevron(dir) {
    var d = dir === 'up' ? 'M2 11 L8 5 L14 11' : 'M2 5 L8 11 L14 5';
    return '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" ' +
           'stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>';
  }

  // Fractional units shown (e.g. 4.5) — drives viewport height / the peek
  function unitsShown() {
    return Math.min(VISIBLE, items.length);
  }

  // Whole thumbnails per page — drives paging + end clamp
  function fullVisible() {
    return Math.max(1, Math.min(Math.floor(VISIBLE), items.length));
  }

  function measure() {
    items = track.querySelectorAll('.product-single__thumbnails-item');
    if (items.length < 2) {
      itemH = items.length ? items[0].offsetHeight : 0;
      gap = 0;
      stride = itemH;
    } else {
      itemH = items[0].offsetHeight;
      stride = items[1].offsetTop - items[0].offsetTop; // height + row-gap
      gap = stride - itemH;
    }
    var u = unitsShown();
    var gaps = Math.max(0, Math.ceil(u) - 1);
    viewport.style.height = (u * itemH + gaps * gap) + 'px';
    maxIndex = Math.max(0, items.length - fullVisible());
  }

  function update() {
    if (index < 0) index = 0;
    if (index > maxIndex) index = maxIndex;
    track.style.transform = 'translateY(' + (-index * stride) + 'px)';

    var noNav = maxIndex <= 0; // everything already fits
    upBtn.style.display = noNav ? 'none' : '';
    downBtn.style.display = noNav ? 'none' : '';
    upBtn.disabled = index <= 0;
    downBtn.disabled = index >= maxIndex;

    // The rail is position:absolute, so it adds no height to the media block.
    // Reserve at least the rail's height so it can't overlap the USP block below.
    var media = wrapper.parentNode;
    if (media) media.style.minHeight = wrapper.offsetHeight + 'px';
  }

  function step() {
    // page by the whole thumbnails on screen
    return fullVisible();
  }

  function build() {
    wrapper = getWrapper();
    if (!wrapper) return;
    track = wrapper.querySelector('.product-single__thumbnails');
    if (!track) return;
    items = track.querySelectorAll('.product-single__thumbnails-item');
    if (!items.length) return;

    // Wrap the rail in a clipping viewport
    viewport = document.createElement('div');
    viewport.className = 'cc-thumb-viewport';
    track.parentNode.insertBefore(viewport, track);
    viewport.appendChild(track);

    // Up / down buttons
    upBtn = document.createElement('button');
    upBtn.type = 'button';
    upBtn.className = 'cc-thumb-nav cc-thumb-nav--up';
    upBtn.setAttribute('aria-label', 'Previous images');
    upBtn.innerHTML = chevron('up');

    downBtn = document.createElement('button');
    downBtn.type = 'button';
    downBtn.className = 'cc-thumb-nav cc-thumb-nav--down';
    downBtn.setAttribute('aria-label', 'Next images');
    downBtn.innerHTML = chevron('down');

    wrapper.insertBefore(upBtn, viewport);
    wrapper.appendChild(downBtn);

    index = 0;
    measure();
    update();

    upBtn.addEventListener('click', function() { index -= step(); update(); });
    downBtn.addEventListener('click', function() { index += step(); update(); });

    // Keep the clicked thumbnail within the visible window
    track.addEventListener('click', function(e) {
      var li = e.target.closest('.product-single__thumbnails-item');
      if (!li) return;
      var i = Array.prototype.indexOf.call(items, li);
      if (i < index) { index = i; update(); }
      else if (i > index + fullVisible() - 1) { index = i - fullVisible() + 1; update(); }
    });

    built = true;
  }

  function destroy() {
    if (!built) return;
    if (wrapper.parentNode) wrapper.parentNode.style.minHeight = ''; // release reserved height
    track.style.transform = '';
    wrapper.insertBefore(track, viewport); // move rail back out
    viewport.remove();
    upBtn.remove();
    downBtn.remove();
    built = false;
  }

  function apply() {
    if (window.innerWidth >= BP) {
      if (!built) build();
      else measure(), update();
    } else if (built) {
      destroy();
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function() {
    apply();
    // Re-measure after images/fonts settle
    setTimeout(apply, 400);
    window.addEventListener('load', apply);
  });

  var rt;
  window.addEventListener('resize', function() {
    clearTimeout(rt);
    rt = setTimeout(apply, 150);
  });
})();
